import TableCellContent, { TableCellContentProps } from "../Table/Row/CellContent";

const TableSimpleCell = (props: TableCellContentProps) => {
  return <TableCellContent {...props} />;
};

TableSimpleCell.displayName = "DS.TableSimple.Cell";

export default TableSimpleCell;
